import { useQuery } from '@tanstack/react-query';

import { fetchStaffOptions } from '../../api/staff-options';
import { useDebouncedValue } from '../../hooks/use-debounced-value';

const SEARCH_DELAY_MS = 250;
const PAGE_SIZE = 20;
const STALE_60S = 60_000;

/** Active users matching what is typed. Nothing is fetched until `enabled`. */
export function useStaffOptions(search: string, enabled: boolean) {
  const term = useDebouncedValue(search, SEARCH_DELAY_MS);
  return useQuery({
    queryKey: ['staff-options', term],
    queryFn: () => fetchStaffOptions(term, PAGE_SIZE),
    enabled,
    staleTime: STALE_60S,
  });
}
